import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * REFERRAL LINK LANDING (2026-10-29).
 *
 * The user asked for *"a link associated to each agents so they can share easily"*. This is where that link
 * lands: it stores the code and sends the visitor to sign up. The code is captured again by the registration
 * route, which is what actually writes the attribution — so a visitor who ignores this page and types the code
 * by hand gets the same result.
 *
 * The code is kept in localStorage rather than the URL alone, so it survives the multi-step signup flow (and a
 * page refresh) without the customer having to remember it.
 */
const STORAGE_KEY = "ogestyle_referral_code";

function JoinReferralPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [saved, setSaved] = useState("");

  useEffect(() => {
    const normalized = String(code || "").trim().toUpperCase();
    if (normalized) {
      try {
        localStorage.setItem(STORAGE_KEY, normalized);
        // Marks that THIS visit came from a link, so the signup form knows not to ask for a code.
        // Without it, an old code left behind by an earlier test hides the field on every later signup.
        sessionStorage.setItem("ogestyle_referral_from_link", "1");
        setSaved(normalized);
      } catch (_) {
        // Private mode / storage disabled: the signup form can still take the code by hand.
      }
    }
    const timer = window.setTimeout(() => navigate("/signup", { replace: true }), 900);
    return () => window.clearTimeout(timer);
  }, [code, navigate]);

  return (
    <div
      style={{
        maxWidth: "520px",
        margin: "0 auto",
        padding: "48px 20px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: "#0f172a",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "22px", marginBottom: "8px" }}>
        You were referred to OGESTYLE
      </h1>
      {saved ? (
        <p style={{ color: "#334155" }}>
          Referral code <strong>{saved}</strong> applied. Taking you to sign
          up…
        </p>
      ) : (
        <p style={{ color: "#334155" }}>Taking you to sign up…</p>
      )}
      <button
        type="button"
        onClick={() => navigate("/signup", { replace: true })}
        style={{
          marginTop: "12px",
          border: "1px solid #1d4ed8",
          background: "#1d4ed8",
          color: "#ffffff",
          borderRadius: "8px",
          padding: "10px 16px",
          fontSize: "14px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Continue to sign up
      </button>
    </div>
  );
}

export default JoinReferralPage;
